<template>
    <div class="contanier">
        <div class="mask"></div>

        <div class="loginForm">
            <div class="form_header">
                <img class="logoImg" src="@/assets/image/index-banner-Icon.webp" alt="" width="40" height="50" >
                <img class="logoImg2" src="@/assets/image/hepha-logo-black.webp" alt="" width="100" height="16" >
                <a-select 
                    v-model="language"
                    :style="{width:'120px',float:'right',marginTop:'10px'}" 
                    placeholder="Select"
                    @change="changeSelect"
                >
                    <a-option value="en">English</a-option>
                    <!-- <a-option value="de">Deutsch</a-option> -->
                    <a-option value="zh">简体中文</a-option>
                </a-select>
                <div class="text">{{ $t('confirmPwd.title') }}</div>
                <div class="subText">{{ $t('confirmPwd.subTitle') }}</div>
            </div>
            <div>
                <a-form
                    :model="form"
                    :style="{marginTop: '10px' }"
                    :size="size"
                >
                    <a-form-item
                        field="name"
                        :hide-label="true"
                        :help="emailMsg"
                        :validate-status="email_status"
                        feedback
                    >
                        <a-input
                            v-model="form.email"
                            allow-clear
                            :placeholder="$t('base.email')"
                    />
                    </a-form-item>
                    <a-form-item
                        field="name"
                        :hide-label="true"
                        :help="newPdwMsg"
                        :validate-status="new_password_status"
                        feedback
                    >
                        <a-input-password
                            v-model="form.new_password"
                            allow-clear
                            :placeholder="$t('base.newPassword')"
                        />
                    </a-form-item>
                    <a-form-item
                        field="name"
                        :hide-label="true"
                        :help="confirmPdwMsg"
                        :validate-status="confirm_password_status"
                        feedback
                    >
                        <a-input-password
                            v-model="form.password"
                            allow-clear
                            :placeholder="$t('base.confirmPassword')"
                            @blur="blur"
                        />
                    </a-form-item>

                    <a-button type="primary" class="signInBtn" @click="confirm">{{ $t('base.confirm') }}</a-button>
                </a-form>
            </div>
            <div class="form_footer">
                {{ $t('confirmPwd.bottomTitle') }} <router-link to="/Login" class="link">{{ $t('base.login') }}</router-link> 
            </div>
        </div>
    </div>
</template>

<script setup>
    import { onMounted, reactive, ref, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import { LoginApi } from '@/api/LoginApi.js';
    import { Message } from '@arco-design/web-vue';
    import { useI18n } from 'vue-i18n';

    const router = useRouter()
    const { t } = useI18n()

    const language = localStorage.getItem('locale')? ref(localStorage.getItem('locale')) : ref('en')
    const emailMsg = ref('')
    const newPdwMsg = ref('')
    const confirmPdwMsg = ref('')
    const email_status = ref('')
    const new_password_status = ref('')
    const confirm_password_status = ref('')
    const form = reactive({
        email:'',
        new_password:'',
        password:''
    })

    const vaild = ()=>{
        if(!form.new_password && !form.password && !form.email){
            emailMsg.value = t('confirmPwd.emailMsgEmpty')
            email_status.value = 'error'
            newPdwMsg.value = t('confirmPwd.newPasswordEmpty')
            new_password_status.value = 'error'
            confirmPdwMsg.value = t('confirmPwd.confirmPasswordEmpty')
            confirm_password_status.value = 'error'

            return false
        }else if(!form.email){
            emailMsg.value = t('confirmPwd.emailMsgEmpty')
            email_status.value = 'error'
            return false
        }else if(!form.new_password){
            newPdwMsg.value = t('confirmPwd.newPasswordEmpty')
            new_password_status.value = 'error'
            return false
        }else if(!form.password){
            confirmPdwMsg.value = t('confirmPwd.confirmPasswordEmpty')
            confirm_password_status.value = 'error'
            return false
        }else if(form.password !== form.new_password){
            confirmPdwMsg.value = t('confirmPwd.vaildPwd')
            confirm_password_status.value = 'error'
            return false
        }

        return true
    }

    const blur = ()=>{
        if(form.password !== form.new_password && form.password){
            confirmPdwMsg.value = t('confirmPwd.vaildPwd')
            confirm_password_status.value = 'error'
        }else{
            confirmPdwMsg.value = ''
            confirm_password_status.value = ''
        }
    }

    const changeSelect = (val)=>{
        localStorage.setItem('locale',val)
        location.reload()
    }

    const confirm = ()=>{
        if(!vaild()) return

        getUserList()
    }

    const resetPassword = async (id)=>{
        let param = {
            new_password: form.new_password,
            password: form.new_password
        }
        let res = await LoginApi.getInstance().resetPassword(param,id)
        if(res.code == 0){
            Message.success(t('confirmPwd.editPwd'))
            router.replace('/Login')
        }else{
            Message.error(res.msg)
        }
    }

    const getUserList = async ()=>{
        let param = {
            email: form.email
        }
        let res = await LoginApi.getInstance().getUserList(param)
        if(res.code == 0){
            let item = res.data.find(i=> i.email == form.email)
            resetPassword(item.id)
        }else{
            Message.error(res.msg)
        }
    }

    watch(()=>form.new_password, (val)=>{
        if(val){
            newPdwMsg.value = ''
            new_password_status.value = ''
        }
    })

    watch(()=>form.password, (val)=>{
        if(val){
            confirmPdwMsg.value = ''
            confirm_password_status.value = ''
        }
    })

    onMounted(()=>{
        
    })


</script>

<style lang="less" scoped>
.contanier{
    width: 100%;
    height: 100vh;
    background:url('@/assets/image/login_bg.webp');

    .mask{
        width: 100%;
        height: 100%;
        background: #333;
        opacity: 0.6;
    }

    .loginForm{
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -35vh;
        margin-top: -30vh;
        padding: 45px;
        width: 70vh;
        height: auto;
        box-sizing: border-box;
        background: #fff;
        border-radius: 5px; 

        .logoImg2{
            margin-left: 10px;
            vertical-align: top;
            margin-top:18px;
        }

        .text{
            margin-top: 20px;
            font-size: 18px;
            font-weight: 600;
        }
        .subText{
            margin-top: 5px;
            font-weight: 300;
            color: #333;
        }

        /deep/ .arco-form-item-content-wrapper{
            margin-top: 15px;
        }

        /deep/ .arco-input-wrapper .arco-input{
            height: 40px;
        }

        /deep/ button:focus, 
        /deep/ button:focus-visible{
            outline: none;
        }

        .signInBtn{
            margin-top: 20px;
            height: 50px;
        }
       
        .form_footer{
            margin-top: 20px;
            width: 90%;
            text-align: center;
            font-size: 16px;
            font-weight: 300;
            box-sizing: border-box;

            .link{
                color: #4d83ff;
            }
        }
        
    }
}
</style>